
import { useEffect } from "react"
import { systemCaseSavedCustomEvent, SystemCaseSavedEvent } from "../types/appTypes";

export default function useSystemCaseSavedEventListener(listener: (event: CustomEvent<SystemCaseSavedEvent>) => void) {
  useEffect(() => {
    const handler: EventListener = (event) => {
      listener(event as CustomEvent<SystemCaseSavedEvent>);
    };
    window.addEventListener(systemCaseSavedCustomEvent, handler)
    return () => {
      window.removeEventListener(systemCaseSavedCustomEvent, handler)
    }
  }, [listener])
}
